import { useTranslator } from '@Localization';
import { ReactElement } from 'react';
import { IProjectActivity, IProjectActivityUpdateQuestionAnswer } from '../../projectDetailsActivities.models';

export const UpdateQuestionAnswerActivity = ({ values }: IProjectActivity<IProjectActivityUpdateQuestionAnswer>): ReactElement => {
  const { t } = useTranslator();
  return (
    <span>
      {t('activity_description_common.updateAnswer')}
      <b>{values.originalAnswer}</b> {t('activity_description_common.to')} <b>{values.answer}</b> {t('activity_description_common.from')}{' '}
      {t('activity_description_common.question')} <b>{values.question}</b>.
    </span>
  );
};
